//#region types
import { InputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import BaseInput from "./baseInput";
import { FormControl } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

function EmailInput(props: InputProps) {
  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <BaseInput {...props} type="email" data-testid={`${props.name}EmailInput`} />
    </FormControl>
  );
}

export default EmailInput;
